<script setup>
import { ref, watchEffect, defineEmits, defineModel } from 'vue';
import BitrixAccountSelect from '@/components/CreateConnectionComponents/BitrixUpload/components/BitrixAccountSelect.vue';
import BitrixDataTypeSelect from '@/components/CreateConnectionComponents/BitrixUpload/components/BitrixDataTypeSelect.vue';
import ConnectionSourceCard from '@/components/CreateConnectionComponents/ConnectionSourceCard.vue';
import BitrixLogo from '@/components/UI/svg/services/BitrixLogo.vue';
import ErrorTriangleSvg from '@/components/UI/svg/ErrorTriangleSvg.vue';

const account = defineModel('account');
const dataType = defineModel('dataType');

const emit = defineEmits(['change-step', 'next-step']);

const isDataInputRight = ref(false);
const errorMessage = ref('');

watchEffect(() => {
    if (account.value === null || account.value === undefined || account.value === '') {
        errorMessage.value = 'Выберите аккаунт';
        isDataInputRight.value = false;
        return;
    }

    if (!dataType.value) {
        errorMessage.value = 'Выберите тип данных';
        isDataInputRight.value = false;
        return;
    }

    errorMessage.value = '';
    isDataInputRight.value = true;
});

function nextStep() {
    emit('next-step');
}
</script>

<template>
    <ConnectionSourceCard
        title="Источник"
        subtitle="Битрикс24"
        show-next-step
        :next-step-enabled="isDataInputRight"
        content-class="pb-28 sm:pb-32"
        @change-step="emit('change-step')"
        @next-step="nextStep"
    >
        <template #icon>
            <BitrixLogo class="w-full h-full object-contain" />
        </template>

        <div class="w-full flex flex-col sm:w-1/2">
            <div class="text-lg font-bold py-2">
                Выбрать аккаунт для выгрузки данных из Битрикс24
            </div>
            <BitrixAccountSelect v-model:account="account" />
        </div>

        <BitrixDataTypeSelect v-model="dataType" />

        <div
            v-show="!isDataInputRight"
            class="flex items-center gap-5 mt-8"
        >
            <ErrorTriangleSvg class="size-6 stroke-white fill-red-500" />
            <div>
                {{ errorMessage }}
            </div>
        </div>
    </ConnectionSourceCard>
</template>
